<div class="show-more-less-wrapper">
  <div #itemList class="item-list">
    <ng-content></ng-content>
  </div>
  <div class="action-button">
    <hdi-button
      [type]="ButtonType.SECONDARY_ICON"
      [label]="toggleLabel | capitalize"
      [iconName]="toggleIcon"
      (click)="toggleVisibility()"
      (keydown)="toggleVisibility()"
    ></hdi-button>
  </div>
</div>
